<template>
  <div class="container">
    <div class="grid">
      <div class="content">
        <div class="title">
          <h1>CUSTOM DESIGN</h1>
          <h4>zippo type lighters</h4>
        </div>
        <router-link to="/quote" class="CTA">Find out more</router-link>
      </div>
      <div class="zippos">
        <div class="zippos-grid">
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo1.webp" alt="custom zippo 1" />
            </div>
          </div>
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo2.webp" alt="custom zippo 1" />
            </div>
          </div>
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo3.webp" alt="custom zippo 1" />
            </div>
          </div>
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo7.webp" alt="custom zippo 1" />
            </div>
          </div>
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo8.webp" alt="custom zippo 1" />
            </div>
          </div>
          <div class="grid-item">
            <div class="zippo-image">
              <img src="@/assets/zippo9.webp" alt="custom zippo 1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.container {
  text-align: center;
  max-width: 1300px;
  margin: 3rem auto;
  padding: 0 1rem;
}

.grid {
  display: grid;
  gap: 2rem;
  text-align: center;
  position: relative;
  grid-template-columns: repeat(1, 1fr);
}
.zippos-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  height: 100%;
}
.grid-item {
  width: 100%;
  height: 100%;
  box-shadow: 5px 6px 5px 1px rgba(0, 0, 0, 0.65);
  border-radius: 15px;
  overflow: hidden;
}
.grid-item .zippo-image {
  width: 100%;
  height: 100%;
}

.grid-item .zippo-image img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  object-position: center;
}

.content {
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}
.title h1 {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-align: center;
  font-size: 1.95rem;
  margin-bottom: 0.5rem;
}
.title h4 {
  color: #d3393d;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.CTA {
  font-family: boombox, Helvetica, Arial, sans-serif;
  display: block;
  margin-top: 1rem;
  max-width: 300px;
  min-width: 150px;
  color: rgb(255, 255, 255);
  padding: 12px 25px;
  border-radius: 22px;
  font-size: 0.85rem;
  text-transform: uppercase;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  background-color: #fa4349;

  transition: all 0.25s ease-in-out;
}
.CTA:hover {
  transform: scale(1.05);
}

/* ----------------------------- Media------------------******************/
@media screen and (min-width: 500px) {
  .title h1 {
    font-size: 3rem;
  }
}
@media screen and (min-width: 768px) {
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0 auto;
  }
  .grid {
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
  .title h1 {
    font-size: 4rem;
  }
  .CTA {
    font-size: 1rem;
  }
  .zippos-grid {
    padding-right: 2rem;
  }
}
</style>